import React from "react";
import { MailToLink } from "./MailToLink";
import { observer } from "mobx-react";
import { useStore } from "@/store";
import { translations } from "@/constants/translations";

interface Props {
  children: React.ReactNode;
  subject?: string;
  body?: string;
}

export const IndigenousMailToLink = observer(
  ({ subject, body, ...props }: Props) => {
    const { activeLanguage } = useStore();
    const language = translations.common.indigenous[activeLanguage];

    return (
      <MailToLink
        {...props}
        href={language.email}
        subject={subject ?? language.email_subject}
        body={body}
      />
    );
  },
);
